import UserNewsApiTempWorker from '@/api/UserNewsApiTempWorker';
import UserNewsApiClient from '@/api/UserNewsApiClient';
import BaseService from '@/services/BaseService';
import useBusService from './BusService';

class UserNewsService extends BaseService {
	async countNotReadAsync (/* ...args: Parameters<typeof UserNewsApiClient.countNotRead> */) {
		if (this.self.isClient()) {
			const { data } = await UserNewsApiClient.countNotRead();
			return data;
		} else if (this.self.isTempWorker()) {
			const { data } = await UserNewsApiTempWorker.countNotRead();
			return data;
		}
		return 0;
	}

	async gridAsync (...args: Parameters<typeof UserNewsApiTempWorker.grid>) {
		if (this.self.isClient()) {
			const { data } = await UserNewsApiClient.grid(...args);
			return data;
		} else if (this.self.isTempWorker()) {
			const { data } = await UserNewsApiTempWorker.grid(...args);
			return data;
		}
	}

	async readAsync (...args: Parameters<typeof UserNewsApiTempWorker.read>) {
		if (this.self.isClient()) {
			await UserNewsApiClient.read(...args);
		} else if (this.self.isTempWorker()) {
			await UserNewsApiTempWorker.read(...args);
		}

		useBusService().emit('user-news:read', ...args);
	}
}

export default function useUserNewsService () {
	return new UserNewsService();
}
